import * as _ from 'underscore';

interface Amenity {
    description : string;
    foldable    : boolean;
}

export default class RoomTypeDescription {

    constructor( public name: string,
                 public alias: string,
                 public route: string,
                 public image: string,
                 public capability: number,
                 private _amenities: (string|[string, boolean])[] ) {
    }

    get amenities(): Amenity[] {
        return this._amenities.map( a => _.isString(a) ?
                                    { description: a, foldable: false } :
                                    { description: a[0], foldable: a[1] } );
    }

}



/** WEBPACK FOOTER **
 ** ./src/models/RoomTypeDescription.ts
 **/